import {NatGetEnvSetting} from './NatGetEnvSetting'
import Http from '../../../../network/Http'


export default class NatEnvSettingRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 環境設定値取得
    async getEnvSetting(): Promise<NatGetEnvSetting> {
        return await this.http.get(`/api/common/envSetting`);
    }
}
